//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { useStore } from '../../store/store';
import { useDispatch } from 'react-redux';
import { processEmail } from 'src/store/profile/actions';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Email, domains } from '@smastrom/react-email-autocomplete';
import getLocale from 'src/localization/get-locale';
import { validateEmail } from 'src/onboarding/helpers/validateEmail';
import styles from './style.module.scss';
import bowl1 from '../../assets/images/bowl1.png';
import bowl2 from '../../assets/images/bowl2.png';
import bowl3 from '../../assets/images/bowl3.png';
import MealCarousel from './components/MealCarousel';
import Reviews from './components/Reviews/Reviews';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';

function Page() {
  const email = useStore((state) => state.email);
  const setEmail = useStore((state) => state.setEmail);
  const dispatch = useDispatch();
  const { onNext, onPrev, currentIndex } = useNav();
  const { showEmailMeals, showEmailReviews } = useRemoteConfig();

  const setPage = useStore((state) => state.setPage);

  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);


  const baseList = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
  ];

  const isIOS = () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  useEffect(() => {
    if (!email) {
      setErrorMessage('');
      setIsValid(false);
    } else if (!validateEmail(email)) {
      setErrorMessage(t('onboarding.email.errorMessage'));
      setIsValid(false);
    } else {
      setErrorMessage('');
      setIsValid(true);
    }
  }, [email]);

  const handleSubmit = useCallback(
    async (value) => {
      if (!isValid) return;
      // @ts-ignore
      window.fbq('track', 'CompleteRegistration');
      await dispatch(processEmail(value));
      await dispatch(reInitRemoteConfig());
    },
    [dispatch, isValid]
  );

  const locale = getLocale();

  const getPaddingLeft = (email: string | undefined, locale: string): number => {
    if (email?.length >= 1) return 0;

    switch (locale) {
      case 'en':
      case 'tr':
        return 80;
      // case 'it':
      // case 'cs': return 60;
      // case 'de':
      // case 'id':
      // case 'fr':
      // case 'pt': return 45;
      // case 'es':  return 40;
      default:
        return 80;
    }
  };

  return (
    <div className='page' style={{ gap: '0px' }}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      {!showEmailMeals && !showEmailReviews && (
        <div className={styles.bowlsContainer}>
          <img src={bowl1} alt='Bowl 1' className={styles.bowlImage} />
          <img src={bowl2} alt='Bowl 2' className={styles.bowlImage} />
          <img src={bowl3} alt='Bowl 3' className={styles.bowlImage} />
        </div>
      )}
      {showEmailMeals && <MealCarousel />}

      {showEmailReviews && <Reviews />}

      <div className='wrapper-info'>
        <Title tag='h2'>
          {showEmailReviews ? t('onboarding.email-2.title2') : t('onboarding.email-2.title1')}
        </Title>
        <Text size='m' medium className='description'>
          {t('onboarding.email-2.subTitle')}
        </Text>
      </div>

      <div className='controls email' style={{ marginTop: '40px' }}>
        <Email
          id='email-field'
          value={email}
          onChange={setEmail}
          placeholder={t('onboarding.email.placeholder')}
          baseList={baseList}
          refineList={domains}
          classNames={{
            wrapper: 'custom-email-wrapper',
            dropdown: styles.customEmailDropdown,
            input: 'custom-email-input',
            suggestion: 'custom-email-suggestion',
            domain: 'custom-email-domain',
          }}
          style={{
            textAlign: (email?.length || 0) >= 1 ? 'center' : 'left',
            caretColor: 'black',
            paddingLeft: getPaddingLeft(email, locale),
          }}
        />
        <Caption size='m' className='error-message' style={{ margin: 0 }}>
          {errorMessage}
        </Caption>
        <span className='info'>
          <span className='top-info'>{t('onboarding.email.topInfo')}</span>
          <span className='bottom-info'>
            <a onClick={() => setPage('privacy-policy')}>{t('onboarding.email.privacyPolicy')}</a>{' '}
            <span className='bottom-info-devider'>&</span>{' '}
            <a onClick={() => setPage('terms-of-use')}>{t('onboarding.email.TermofUse')}</a>
          </span>
        </span>
        <div className={`next-wrapper`}>
          <Button
            className={!isValid ? 'disabled' : ''}
            title={t('onboarding.email.continue')}
            onClick={() => {
              if (!isValid) return;
              handleSubmit(email);
              Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                page: 'email',
                answer: email,
              });

              gtag('event', 'conversion', {
                send_to: 'AW-17149973324/cDa6CIPlt_0aEMym3_E_',
                value: 1.0,
                currency: 'USD',
              });

              onNext();
            }}
          />
        </div>
      </div>
      {/* <div className={`button-white-bg ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}></div> */}
    </div>
  );
}

export default Page;
